'use es6';

import { create } from './strings';
const {
  get
} = create('excludes', 'e');
export { get };